import { SocialProofBlock } from './SocialProofBlock'
import type { ShowcasePage as ShowcasePageType } from '@/content/quiz/types'

interface ShowcasePageProps {
  page: ShowcasePageType
  onContinue: () => void
  isLastPage?: boolean
}

export function ShowcasePage({ page, onContinue, isLastPage }: ShowcasePageProps) {
  return (
    <div className="space-y-6">
      <img
        src={page.image}
        alt={page.title}
        className="w-full rounded-xl object-cover aspect-video"
      />
      <h2 className="text-xl font-semibold text-slate-900">{page.title}</h2>
      <p className="text-slate-600 leading-relaxed">{page.description}</p>
      {page.socialProof && (
        <SocialProofBlock config={page.socialProof} className="mt-6" />
      )}
    </div>
  )
}
